import { useState as s, useEffect as i } from "react";
import { useTranslation as d, toast as c } from "@systemeio/ui";
import { usePublicKeysStore as p } from "../../../store/index.mjs";
import a from "../../../utils/load-script.mjs";
const w = () => {
  const { t: o } = d(), t = typeof window < "u" && !!window.Xendit, [r, n] = s(!t), { xenditPublicKey: e } = p();
  return i(() => {
    t || a("https://js.xendit.co/v1/xendit.min.js", "xendit-js", () => {
      n(!1);
    });
  }, [t]), i(() => {
    t && (window.Xendit && e ? window.Xendit.setPublishableKey(e) : c.error(o("public_pages_purchase.error")));
  }, [t, e]), {
    isScriptLoading: r
  };
};
export {
  w as useLoadXenditScript
};
